import {Link} from 'react-router-dom';
import type {SegmentedFilterProps} from './types';
import './segmented-filter.scss';

export function SegmentedFilter<T extends string>({
    activeId,
    ariaLabel,
    className,
    compact = false,
    onChange,
    options
}: SegmentedFilterProps<T>) {
    const rootClassName = [
        'segmented-filter',
        compact ? 'segmented-filter--compact' : '',
        className ?? ''
    ].filter(Boolean).join(' ');

    return (
        <div className={rootClassName} aria-label={ariaLabel}>
            {options.map(option => {
                const isActive = option.id === activeId;
                const itemClassName = `segmented-filter__item ${isActive ? 'is-active' : ''}`;

                return option.to ? (
                    <Link
                        className={itemClassName}
                        to={option.to}
                        aria-current={isActive ? 'page' : undefined}
                        key={option.id}
                    >
                        {option.label}
                    </Link>
                ) : (
                    <button
                        type="button"
                        className={itemClassName}
                        aria-pressed={isActive}
                        onClick={() => onChange?.(option.id)}
                        key={option.id}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
